import { render, staticRenderFns } from "./AnimatedFlipCounter.vue?vue&type=template&id=1a279ff8&lang=pug"
import script from "./AnimatedFlipCounter.vue?vue&type=script&lang=js"
export * from "./AnimatedFlipCounter.vue?vue&type=script&lang=js"
import style0 from "./AnimatedFlipCounter.vue?vue&type=style&index=0&id=1a279ff8&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports